import React from 'react';

export const SubMenu = ({ subMenuContent, padding }) => {
  return (
    <ul className="submenu" style={{ paddingLeft: padding }}>
      {subMenuContent}
    </ul>
  );
};
